<template>
  <vs-row>
    <vs-col
      vs-lg="12"
      vs-type="flex"
      class="pt-2 border-top"
    >

      <vs-chip
        data-cy="billing-status"
        class="mr-3"
        v-tooltip="file.emisor.status ?
        'El proceso se ejecutará llegando el día configurado':
        'El proceso no se ejecutará'"
      >
        <vs-avatar
          :icon="file.emisor.status ? 'check' : 'do_not_disturb'"
          :color="file.emisor.status ? this.colores.primario : this.colores.navbar"
        />
        {{ file.emisor.status ? 'Activo' : 'Inactivo' }}
      </vs-chip>
      <vs-chip
        data-cy="billing-status"
        class="mr-3"
        v-tooltip="'Estado de ejecución: '+file.executionState"
      >
        <vs-avatar
          :icon="file.executionState == 'ok' ?
          'check' :file.executionState == 'pending' ?
           'do_not_disturb' : 'lock'"
          :color="file.executionState == 'ok' ?
           'green' :file.executionState == 'pending' ?
            this.colores.navbar: 'red'"
        />
        {{
          file.executionState == 'ok' ?
        'Ejecutado' :file.executionState == 'pending' ?
          'Pendiente' : 'Error'
        }}
      </vs-chip>
      <vs-chip
        v-if="file.emisor.esEnCuota"
        data-cy="billing-cuote"
        class="mr-3"
        v-tooltip="file.emisor.esEnCuota ?
        'Es en cuotas':
        'No es en cuotas'"
      >
        <vs-avatar
          :icon="'credit_card'"
          :color="this.colores.primario"
        />
        En cuota {{ file.emisor.numCuota }} de {{ file.emisor.numCuotas }}
      </vs-chip>
      <vs-chip
        data-cy="billing-save-as-draf"
        class="mr-3"
        v-tooltip="file.emisor.saveAsDraf ?
        'Se guarda como borrador':
        'Se intenta emitir documento'"
      >
        <vs-avatar
          :icon="file.emisor.saveAsDraf ? 'draw' : 'print'"
          :color="file.emisor.saveAsDraf ? this.colores.primario : this.colores.navbar"
        />
        {{ file.emisor.saveAsDraf ? 'Borrador' : 'Emitir' }}
      </vs-chip>
      <vs-chip
        data-cy="next-billing-type-amount"
        class="mr-4"
        v-tooltip="+file.emisor.type === 34 ?
        'Factura exenta'
        :
        'Factura afecta'
        "
      >
        <vs-avatar
          icon="title"
          :color="+file.emisor.type === 33 ?  this.colores.primario : this.colores.navbar"
        />
        <span>
          {{ file.emisor.type || 33 }}
        </span>
      </vs-chip>
      <vs-chip
        data-cy="next-billing-type-amount"
        class="mr-4"
        v-tooltip="file.detalle.bruto ?
        'Este monto ya cuenta con el iva'
        :
        'Se calculará el iva sobre este monto'
        "
      >
        <vs-avatar
          icon="attach_money"
          :color="!file.detalle.bruto ?  this.colores.primario : this.colores.navbar"
        />
        <span v-if="file.detalle.bruto">
          Bruto
        </span>
        <span v-if="!file.detalle.bruto">
          Neto
        </span>
      </vs-chip>
      <vs-chip
        data-cy="next-billing-type"
        class="mr-4"
        v-tooltip="'Fecha de facturación'"
      >
        <vs-avatar icon="date_range"/>
        <span v-if="file.emisor.dayType === 'P'">
          Primer día del mes
        </span>
        <span v-if="file.emisor.dayType === 'U'">
          Último día del mes
        </span>
        <span v-if="file.emisor.dayType === 'otro'">
          El día {{ file.emisor.day }} de cada mes
        </span>
      </vs-chip>
      <vs-chip
        data-cy="next-billing-hour"
        class="mr-4"
        v-tooltip="'Hora de ejecución'"
      >
        <vs-avatar
          icon="hourglass_empty"
        />
        <span>
          {{ file.emisor.hour || '0' }}
        </span>
      </vs-chip>
      <vs-chip
        data-cy="next-billing-date-valid"
        class="mr-4"
        v-tooltip="'Valido hasta'"
        v-if="file.emisor.validityDate"
      >
        <vs-avatar
          icon="hourglass_empty"
          :color="isValidDate ? 'green' : 'red' "
        />
        <span>
          {{ file.emisor.validityDate }}
        </span>
      </vs-chip>
    </vs-col>
  </vs-row>
</template>
<script>
import { mapGetters } from 'vuex';
import Vue from 'vue';

import PersonalizacionMixin from '@/febos/global/empresas/mixins/PersonalizacionMixin';

export default {
  mixins: [PersonalizacionMixin],
  data() {
    return {};
  },
  props: [
    'file'
  ],
  computed: {
    ...mapGetters('Usuario', ['currentUserId']),
    ...mapGetters('Empresas', ['company']),
    isValidDate() {
      if (this.file.emisor.validityDate) {
        const date = Vue.moment(this.file.emisor.validityDate);
        const today = Vue.moment();
        const diff = date.diff(today, 'days');
        if (diff >= 0) {
          return true;
        }
      }
      return false;
    }
  }
};
</script>
